export function getAccountDisplayName(email: string | undefined, fallback: string): string {
  return email ?? fallback
}
